import Vue from 'vue';
import { normalizeModelName } from '../utils';

Vue.component('configurator-price-indicator', {
    props: {
        linkBuilder: {
            required: false,
        },
    },
    data() {
        return {
            indicatorEnabled: false,
            priceAvailable: true,
            directPaymentEnabled: false,
            priceText: '',
            comingSoonText: null,
        };
    },

    mounted() {
        // Update price text and enable indicator if a new price is set.
        EventBus.$on(
            'configurator-price-update',
            (priceText, formattedPriceText) => {
                this.priceText = formattedPriceText;
                this.priceAvailable = true;
                this.indicatorEnabled = true;
            },
        );

        // Set price n/a and enable indicator if a new price is unavailable.
        EventBus.$on('configurator-price-na', () => {
            this.priceText = '';
            this.priceAvailable = false;
            this.indicatorEnabled = true;
        });

        EventBus.$on('configurator-price-coming-soon', (text) => {
            this.indicatorEnabled = true;
            this.comingSoonText = text;
        });

        // Disable price indicator if so required.
        EventBus.$on('configurator-price-disable', () => {
            if (this.comingSoonText) return;
            this.indicatorEnabled = false;
        });

        // Enable or disable buy bow button.
        EventBus.$on('configurator-set-payment-option', (paymentOption) => {
            this.directPaymentEnabled =
                paymentOption.field_paymentOption_paymentEnabled === '1';
        });
    },

    methods: {
        shouldDisableButton() {
            return Boolean(this.comingSoonText);
        },

        completeConfigurator() {
            this.$parent.completeConfigurator();

            if (this.$parent.siteHandle == 'mgMotorsFrance') {
                const dodDescription = `Lead ayant configuré un/une ${normalizeModelName(
                    this.$parent.model,
                )} sur le site mgmotor.fr.`;

                const calculatorResultForDod = {
                    isAgricoleCalculation: false,
                    dodDescription,
                };
                EventBus.$emit(
                    'agricole-calculator-finished',
                    calculatorResultForDod,
                );
                EventBus.$emit(
                    'toggle-agricole-calculator-footer-notes',
                    false,
                );
            }
        },
    },
});
